'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_magnolia1$002e$002dCase$002dClass$0024$002dParam$0024$0024anon$00242 from "./magnolia1.-Case-Class$-Param$$anon$2.js";
import * as $j_magnolia1$002e$002dCase$002dClass$002dDerivation$0024$0024anon$00241 from "./magnolia1.-Case-Class-Derivation$$anon$1.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
var $p;
function $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param($thiz, label, tc, d, repeated, annotations, inheritedAnnotations, typeAnnotations, idx) {
  var repeated$1 = (!(!repeated.ex(label, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => false)))));
  var it = annotations.ex(label, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_java$002elang$002e$002dObject.$m_sci_Nil$())));
  var n = it.P();
  if ((n > (-1))) {
    var elements = new $j_java$002elang$002e$002dObject.$ac_O(n);
    var iterator = it.s();
    var i = 0;
    while ((i < n)) {
      elements.a[i] = iterator.e();
      i = ((1 + i) | 0);
    }
    var s = elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var iterator$2 = it.s();
    while (iterator$2.i()) {
      var elem = iterator$2.e();
      var unboxedElem = ((elem === null) ? $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().le($j_java$002elang$002e$002dObject.$d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var s = $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().ld($j_java$002elang$002e$002dObject.$d_O.l(), jsElems);
  }
  var it$1 = inheritedAnnotations.ex(label, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_java$002elang$002e$002dObject.$m_sci_Nil$())));
  var n$1 = it$1.P();
  if ((n$1 > (-1))) {
    var elements$1 = new $j_java$002elang$002e$002dObject.$ac_O(n$1);
    var iterator$1 = it$1.s();
    var i$1 = 0;
    while ((i$1 < n$1)) {
      elements$1.a[i$1] = iterator$1.e();
      i$1 = ((1 + i$1) | 0);
    }
    var s$1 = elements$1;
  } else {
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    size$1 = 0;
    jsElems$1 = [];
    var iterator$2$1 = it$1.s();
    while (iterator$2$1.i()) {
      var elem$1 = iterator$2$1.e();
      var unboxedElem$1 = ((elem$1 === null) ? $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().le($j_java$002elang$002e$002dObject.$d_O.l()) : elem$1);
      jsElems$1.push(unboxedElem$1);
    }
    var s$1 = $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().ld($j_java$002elang$002e$002dObject.$d_O.l(), jsElems$1);
  }
  var it$2 = typeAnnotations.ex(label, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_java$002elang$002e$002dObject.$m_sci_Nil$())));
  var n$2 = it$2.P();
  if ((n$2 > (-1))) {
    var elements$2 = new $j_java$002elang$002e$002dObject.$ac_O(n$2);
    var iterator$3 = it$2.s();
    var i$2 = 0;
    while ((i$2 < n$2)) {
      elements$2.a[i$2] = iterator$3.e();
      i$2 = ((1 + i$2) | 0);
    }
    var $x_1 = elements$2;
  } else {
    var capacity$2 = 0;
    var size$2 = 0;
    var jsElems$2 = null;
    capacity$2 = 0;
    size$2 = 0;
    jsElems$2 = [];
    var iterator$2$2 = it$2.s();
    while (iterator$2$2.i()) {
      var elem$2 = iterator$2$2.e();
      var unboxedElem$2 = ((elem$2 === null) ? $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().le($j_java$002elang$002e$002dObject.$d_O.l()) : elem$2);
      jsElems$2.push(unboxedElem$2);
    }
    var $x_1 = $j_java$002elang$002e$002dObject.$m_scm_ArrayBuilder$().ld($j_java$002elang$002e$002dObject.$d_O.l(), jsElems$2);
  }
  return new $j_magnolia1$002e$002dCase$002dClass$0024$002dParam$0024$0024anon$00242.$c_Lmagnolia1_CaseClass$Param$$anon$2(label, idx, repeated$1, s, $x_1, d, tc, s$1);
}
export { $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param as $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param };
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$() {
  this.a0 = null;
  $n_Lmagnolia1_CaseClassDerivation$ = this;
  this.a0 = new $j_magnolia1$002e$002dCase$002dClass$002dDerivation$0024$0024anon$00241.$c_Lmagnolia1_CaseClassDerivation$$anon$1();
}
export { $c_Lmagnolia1_CaseClassDerivation$ as $c_Lmagnolia1_CaseClassDerivation$ };
$p = $c_Lmagnolia1_CaseClassDerivation$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CaseClassDerivation$;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$() {
}
export { $h_Lmagnolia1_CaseClassDerivation$ as $h_Lmagnolia1_CaseClassDerivation$ };
$h_Lmagnolia1_CaseClassDerivation$.prototype = $p;
var $d_Lmagnolia1_CaseClassDerivation$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CaseClassDerivation$, "magnolia1.CaseClassDerivation$", ({
  nO: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$ as $d_Lmagnolia1_CaseClassDerivation$ };
var $n_Lmagnolia1_CaseClassDerivation$;
function $m_Lmagnolia1_CaseClassDerivation$() {
  if ((!$n_Lmagnolia1_CaseClassDerivation$)) {
    $n_Lmagnolia1_CaseClassDerivation$ = new $c_Lmagnolia1_CaseClassDerivation$();
  }
  return $n_Lmagnolia1_CaseClassDerivation$;
}
export { $m_Lmagnolia1_CaseClassDerivation$ as $m_Lmagnolia1_CaseClassDerivation$ };
